import { Box } from "@mui/material";
import { LOCAL_STORAGE_GRID_KEYS } from "../../_constants";
import { getGridContextMenuList } from "../../_helpers/getGridContextMenuList";
import { LabelColumnV2, LinkColumnV2 } from "../../components/DataGridV2/DataColumnsV2";
import { BookmarksOutlined, ChatOutlined, ForumOutlined } from "@mui/icons-material";

export const getProjectOverviewColumns = ({
  t,
  keyPrefix,
  i18n,
  apiRef,
  all,
  theme
}) => {
  const getOptions = getGridContextMenuList({
    filterKey: LOCAL_STORAGE_GRID_KEYS.PROJECT_OVERVIEW_COLUMN_FILTER[keyPrefix],
    sortKey: LOCAL_STORAGE_GRID_KEYS.PROJECT_OVERVIEW_COLUMN_SORT[keyPrefix],
    i18n,
    t,
    apiRef,
    getValueForFilter: (rowData, extraData) => {
      let text = ""
      switch (extraData.fieldName) {
        case "noOfSavedMessages":
          text = rowData.noOfSavedMessages != null ? rowData.noOfSavedMessages.toString() : "";
          break;
        case "noOfUnreadMessages":
          text = rowData.noOfUnreadMessages != null ? rowData.noOfUnreadMessages.toString() : "";
          break;
        case "noOfUnreadChats":
          text = rowData.noOfUnreadChats != null ? rowData.noOfUnreadChats.toString() : "";
          break;
        default:
          text = rowData[extraData.fieldName]
          break;
      }
      return text
    },
    mode: "client"
  })

  return [
    {
      field: "projectNo",
      headerName: t("general.projectNumber"),
      flex: 1,
      sortable: 'true',
      download: true,
      renderCell: (params) => {
        const rowData = params.row;
        const selectedProject = all.find(x => x.projectId === rowData.projectId);
        return (
          <LinkColumnV2
            to={"/werk/" + selectedProject.projectNo}
            label={rowData.projectNo}
            cellSubMenuOptions={{ options: getOptions({ field: "projectNo", isQuickFilterDisplay: rowData?.projectNo }), extraData: { fieldName: "projectNo", } }}
            request={rowData}
          />
        );
      },
    },
    {
      field: "projectName",
      headerName: t("general.projectName"),
      flex: 1,
      sortable: 'true',
      download: true,
      renderCell: (params) => {
        const rowData = params.row;
        return (
          <LabelColumnV2
            label={rowData.projectName}
            cellSubMenuOptions={{ options: getOptions({ field: "projectName", isQuickFilterDisplay: rowData?.projectName }), extraData: { fieldName: "projectName", } }}
            request={rowData}
          />
        );
      },
    },
    {
      field: "place",
      headerName: t("general.address.city"),
      flex: 1,
      sortable: 'true',
      download: true,
      renderCell: (params) => {
        const rowData = params.row;
        return (
          <LabelColumnV2
            label={rowData.place}
            cellSubMenuOptions={{ options: getOptions({ field: "place", isQuickFilterDisplay: rowData?.place }), extraData: { fieldName: "place", } }}
            request={rowData}
          />
        );
      },
    },
    {
      field: "projectType",
      headerName: t("general.type"),
      flex: 1,
      sortable: 'true',
      download: true,
      renderCell: (params) => {
        const rowData = params.row;
        return (
          <LabelColumnV2
            label={rowData.projectType}
            cellSubMenuOptions={{ options: getOptions({ field: "projectType", isQuickFilterDisplay: Boolean(rowData?.projectType) }), extraData: { fieldName: "projectType", } }}
            request={rowData}
          />
        );
      },
    },
    {
      field: "projectConstructionType",
      headerName: t("general.project.constructionType"),
      flex: 1,
      sortable: 'true',
      download: true,
      renderCell: (params) => {
        const rowData = params.row;
        return (
          <LabelColumnV2
            label={rowData.projectConstructionType}
            cellSubMenuOptions={{ options: getOptions({ field: "projectConstructionType", isQuickFilterDisplay: Boolean(rowData?.projectConstructionType) }), extraData: { fieldName: "projectConstructionType", } }}
            request={rowData}
          />
        );
      },
    },
    {
      field: "projectPhase",
      headerName: t("general.phase"),
      flex: 1,
      sortable: 'true',
      download: true,
      renderCell: (params) => {
        const rowData = params.row;
        return (
          <LabelColumnV2
            label={rowData.projectPhase}
            cellSubMenuOptions={{ options: getOptions({ field: "projectPhase", isQuickFilterDisplay: Boolean(rowData?.projectPhase) }), extraData: { fieldName: "projectPhase", } }}
            request={rowData}
          />
        );
      },
    },
    {
      field: "noOfUnreadChats",
      headerName: t("chat.chats"),
      flex: 1,
      sortable: 'true',
      download: true,
      minWidth: 45,
      maxWidth: 45,
      headerAlign: "center",
      renderHeader: () => (
        <Box sx={{
          mr: 0.6
        }}>
          <ForumOutlined size="small" />
        </Box>
      ),
      renderCell: (params) => {
        const rowData = params.row;
        return (
          <LabelColumnV2
            label={rowData.noOfUnreadChats}
            cellSubMenuOptions={{ options: getOptions({ field: "noOfUnreadChats", isQuickFilterDisplay: Boolean(rowData?.noOfUnreadChats) }), extraData: { fieldName: "noOfUnreadChats", } }}
            request={rowData}
          />
        );
      },
    },
    {
      field: "noOfUnreadMessages",
      headerName: t("chat.messages"),
      flex: 1,
      minWidth: 45,
      maxWidth: 45,
      sortable: 'true',
      headerAlign: "center",
      download: true,
      renderHeader: () => (
        <Box sx={{
          mr: 0.6
        }}>
          <ChatOutlined size="small" />
        </Box>
      ),
      renderCell: (params) => {
        const rowData = params.row;
        return (
          <LabelColumnV2
            label={rowData.noOfUnreadMessages > 0 ? <span style={{ color: theme.palette.success.main }}>{rowData.noOfUnreadMessages}</span> : 0}
            cellSubMenuOptions={{ options: getOptions({ field: "noOfUnreadMessages", isQuickFilterDisplay: Boolean(rowData?.noOfUnreadMessages) }), extraData: { fieldName: "noOfUnreadMessages", } }}
            request={rowData}
          />
        );
      },
    },
    {
      field: "noOfSavedMessages",
      headerName: t("chat.importantMessages"),
      flex: 1,
      minWidth: 45,
      maxWidth: 45,
      sortable: 'true',
      download: true,
      headerAlign: "center",
      renderHeader: () => (
        <Box sx={{
          mr: 0.6
        }}>
          <BookmarksOutlined size="small" />
        </Box>
      ),
      renderCell: (params) => {
        const rowData = params.row;
        return (
          <LabelColumnV2
            label={rowData.noOfSavedMessages}
            cellSubMenuOptions={{ options: getOptions({ field: "noOfSavedMessages", isQuickFilterDisplay: Boolean(rowData?.noOfSavedMessages) }), extraData: { fieldName: "noOfSavedMessages", } }}
            request={rowData}
          />
        );
      },
    },
  ];
}


